export const EMOJI_CATEGORIES = {
  recent: [],
  smileys: [
    { emoji: "😀", name: "Grinning Face" },
    { emoji: "😃", name: "Grinning Face with Big Eyes" },
    { emoji: "😄", name: "Grinning Face with Smiling Eyes" },
    { emoji: "😁", name: "Beaming Face with Smiling Eyes" },
    { emoji: "😆", name: "Grinning Squinting Face" },
    { emoji: "😅", name: "Grinning Face with Sweat" },
    { emoji: "🤣", name: "Rolling on the Floor Laughing" },
    { emoji: "😂", name: "Face with Tears of Joy" },
    { emoji: "🙂", name: "Slightly Smiling Face" },
    { emoji: "🙃", name: "Upside-Down Face" },
    { emoji: "😉", name: "Winking Face" },
    { emoji: "😊", name: "Smiling Face with Smiling Eyes" },
    { emoji: "😇", name: "Smiling Face with Halo" },
    { emoji: "🥰", name: "Smiling Face with Hearts" },
    { emoji: "😍", name: "Smiling Face with Heart-Eyes" },
    { emoji: "🤩", name: "Star-Struck" },
    { emoji: "😘", name: "Face Blowing a Kiss" },
    { emoji: "😗", name: "Kissing Face" },
    { emoji: "😚", name: "Kissing Face with Closed Eyes" },
    { emoji: "😙", name: "Kissing Face with Smiling Eyes" },
    { emoji: "😋", name: "Face Savoring Food" },
    { emoji: "😛", name: "Face with Tongue" },
    { emoji: "😜", name: "Winking Face with Tongue" },
    { emoji: "🤪", name: "Zany Face" },
    { emoji: "😝", name: "Squinting Face with Tongue" },
    { emoji: "🤑", name: "Money-Mouth Face" },
    { emoji: "🤗", name: "Hugging Face" },
    { emoji: "🤭", name: "Face with Hand Over Mouth" },
    { emoji: "🤫", name: "Shushing Face" },
    { emoji: "🤔", name: "Thinking Face" },
    { emoji: "🤐", name: "Zipper-Mouth Face" },
    { emoji: "🤨", name: "Face with Raised Eyebrow" },
    { emoji: "😐", name: "Neutral Face" },
    { emoji: "😑", name: "Expressionless Face" },
    { emoji: "😶", name: "Face Without Mouth" },
    { emoji: "😏", name: "Smirking Face" },
    { emoji: "😒", name: "Unamused Face" },
    { emoji: "🙄", name: "Face with Rolling Eyes" },
    { emoji: "😬", name: "Grimacing Face" },
    { emoji: "🤥", name: "Lying Face" },
    { emoji: "😌", name: "Relieved Face" },
    { emoji: "😔", name: "Pensive Face" },
    { emoji: "😪", name: "Sleepy Face" },
    { emoji: "🤤", name: "Drooling Face" },
    { emoji: "😴", name: "Sleeping Face" },
    { emoji: "😷", name: "Face with Medical Mask" },
    { emoji: "🤒", name: "Face with Thermometer" },
    { emoji: "🤕", name: "Face with Head-Bandage" },
    { emoji: "🤢", name: "Nauseated Face" },
    { emoji: "🤮", name: "Face Vomiting" },
    { emoji: "🤧", name: "Sneezing Face" },
    { emoji: "🥵", name: "Hot Face" },
    { emoji: "🥶", name: "Cold Face" },
    { emoji: "😵", name: "Dizzy Face" },
    { emoji: "🤯", name: "Exploding Head" },
    { emoji: "🤠", name: "Cowboy Hat Face" },
    { emoji: "🥳", name: "Partying Face" },
    { emoji: "😎", name: "Smiling Face with Sunglasses" },
    { emoji: "🤓", name: "Nerd Face" },
    { emoji: "🧐", name: "Face with Monocle" },
    { emoji: "😕", name: "Confused Face" },
    { emoji: "😟", name: "Worried Face" },
    { emoji: "🙁", name: "Slightly Frowning Face" },
    { emoji: "😮", name: "Face with Open Mouth" },
    { emoji: "😯", name: "Hushed Face" },
    { emoji: "😲", name: "Astonished Face" },
    { emoji: "😳", name: "Flushed Face" },
    { emoji: "🥺", name: "Pleading Face" },
    { emoji: "😦", name: "Frowning Face with Open Mouth" },
    { emoji: "😧", name: "Anguished Face" },
    { emoji: "😨", name: "Fearful Face" },
    { emoji: "😰", name: "Anxious Face with Sweat" },
    { emoji: "😥", name: "Sad but Relieved Face" },
    { emoji: "😢", name: "Crying Face" },
    { emoji: "😭", name: "Loudly Crying Face" },
    { emoji: "😱", name: "Face Screaming in Fear" },
    { emoji: "😖", name: "Confounded Face" },
    { emoji: "😣", name: "Persevering Face" },
    { emoji: "😞", name: "Disappointed Face" },
    { emoji: "😓", name: "Downcast Face with Sweat" },
    { emoji: "😩", name: "Weary Face" },
    { emoji: "😫", name: "Tired Face" },
    { emoji: "🥱", name: "Yawning Face" },
    { emoji: "😤", name: "Face with Steam from Nose" },
    { emoji: "😡", name: "Pouting Face" },
    { emoji: "😠", name: "Angry Face" },
    { emoji: "🤬", name: "Face with Symbols on Mouth" },
    { emoji: "😈", name: "Smiling Face with Horns" },
    { emoji: "👿", name: "Angry Face with Horns" },
    { emoji: "💀", name: "Skull" },
    { emoji: "☠️", name: "Skull and Crossbones" },
    { emoji: "💩", name: "Pile of Poo" },
    { emoji: "🤡", name: "Clown Face" },
    { emoji: "👹", name: "Ogre" },
    { emoji: "👺", name: "Goblin" },
    { emoji: "👻", name: "Ghost" },
    { emoji: "👽", name: "Alien" },
    { emoji: "👾", name: "Alien Monster" },
    { emoji: "🤖", name: "Robot" },
  ],
  animals: [
    { emoji: "🐶", name: "Dog Face" },
    { emoji: "🐱", name: "Cat Face" },
    { emoji: "🐭", name: "Mouse Face" },
    { emoji: "🐹", name: "Hamster" },
    { emoji: "🐰", name: "Rabbit Face" },
    { emoji: "🦊", name: "Fox" },
    { emoji: "🐻", name: "Bear" },
    { emoji: "🐼", name: "Panda" },
    { emoji: "🐨", name: "Koala" },
    { emoji: "🐯", name: "Tiger Face" },
    { emoji: "🦁", name: "Lion" },
    { emoji: "🐮", name: "Cow Face" },
    { emoji: "🐷", name: "Pig Face" },
    { emoji: "🐽", name: "Pig Nose" },
    { emoji: "🐸", name: "Frog" },
    { emoji: "🐵", name: "Monkey Face" },
    { emoji: "🙈", name: "See-No-Evil Monkey" },
    { emoji: "🙉", name: "Hear-No-Evil Monkey" },
    { emoji: "🙊", name: "Speak-No-Evil Monkey" },
    { emoji: "🐒", name: "Monkey" },
    { emoji: "🐔", name: "Chicken" },
    { emoji: "🐧", name: "Penguin" },
    { emoji: "🐦", name: "Bird" },
    { emoji: "🐤", name: "Baby Chick" },
    { emoji: "🐣", name: "Hatching Chick" },
    { emoji: "🐥", name: "Front-Facing Baby Chick" },
    { emoji: "🦆", name: "Duck" },
    { emoji: "🦅", name: "Eagle" },
    { emoji: "🦉", name: "Owl" },
    { emoji: "🦇", name: "Bat" },
    { emoji: "🐺", name: "Wolf" },
    { emoji: "🐗", name: "Boar" },
    { emoji: "🐴", name: "Horse Face" },
    { emoji: "🦄", name: "Unicorn" },
    { emoji: "🐝", name: "Honeybee" },
    { emoji: "🐛", name: "Bug" },
    { emoji: "🦋", name: "Butterfly" },
    { emoji: "🐌", name: "Snail" },
    { emoji: "🐞", name: "Lady Beetle" },
    { emoji: "🐜", name: "Ant" },
    { emoji: "🦗", name: "Cricket" },
    { emoji: "🕷️", name: "Spider" },
    { emoji: "🦂", name: "Scorpion" },
    { emoji: "🦀", name: "Crab" },
    { emoji: "🦑", name: "Squid" },
    { emoji: "🐙", name: "Octopus" },
    { emoji: "🦐", name: "Shrimp" },
    { emoji: "🐠", name: "Tropical Fish" },
    { emoji: "🐟", name: "Fish" },
    { emoji: "🐡", name: "Blowfish" },
    { emoji: "🐬", name: "Dolphin" },
    { emoji: "🦈", name: "Shark" },
    { emoji: "🐳", name: "Spouting Whale" },
    { emoji: "🐋", name: "Whale" },
    { emoji: "🐊", name: "Crocodile" },
    { emoji: "🐅", name: "Tiger" },
    { emoji: "🐆", name: "Leopard" },
    { emoji: "🦓", name: "Zebra" },
    { emoji: "🦍", name: "Gorilla" },
    { emoji: "🐘", name: "Elephant" },
    { emoji: "🦏", name: "Rhinoceros" },
    { emoji: "🐪", name: "Camel" },
    { emoji: "🐫", name: "Two-Hump Camel" },
    { emoji: "🦒", name: "Giraffe" },
  ],
  food: [
    { emoji: "🍏", name: "Green Apple" },
    { emoji: "🍎", name: "Red Apple" },
    { emoji: "🍐", name: "Pear" },
    { emoji: "🍊", name: "Tangerine" },
    { emoji: "🍋", name: "Lemon" },
    { emoji: "🍌", name: "Banana" },
    { emoji: "🍉", name: "Watermelon" },
    { emoji: "🍇", name: "Grapes" },
    { emoji: "🍓", name: "Strawberry" },
    { emoji: "🍈", name: "Melon" },
    { emoji: "🍒", name: "Cherries" },
    { emoji: "🍑", name: "Peach" },
    { emoji: "🥭", name: "Mango" },
    { emoji: "🍍", name: "Pineapple" },
    { emoji: "🥥", name: "Coconut" },
    { emoji: "🥝", name: "Kiwi Fruit" },
    { emoji: "🍅", name: "Tomato" },
    { emoji: "🍆", name: "Eggplant" },
    { emoji: "🥑", name: "Avocado" },
    { emoji: "🥦", name: "Broccoli" },
    { emoji: "🥬", name: "Leafy Green" },
    { emoji: "🥒", name: "Cucumber" },
    { emoji: "🌶️", name: "Hot Pepper" },
    { emoji: "🌽", name: "Ear of Corn" },
    { emoji: "🥕", name: "Carrot" },
    { emoji: "🥔", name: "Potato" },
    { emoji: "🍠", name: "Roasted Sweet Potato" },
    { emoji: "🥐", name: "Croissant" },
    { emoji: "🥯", name: "Bagel" },
    { emoji: "🍞", name: "Bread" },
    { emoji: "🥖", name: "Baguette Bread" },
    { emoji: "🥨", name: "Pretzel" },
    { emoji: "🧀", name: "Cheese Wedge" },
    { emoji: "🥚", name: "Egg" },
    { emoji: "🍳", name: "Cooking" },
    { emoji: "🥞", name: "Pancakes" },
    { emoji: "🥓", name: "Bacon" },
    { emoji: "🥩", name: "Meat on Bone" },
    { emoji: "🍗", name: "Poultry Leg" },
    { emoji: "🍖", name: "Meat on Bone" },
    { emoji: "🌭", name: "Hot Dog" },
    { emoji: "🍔", name: "Hamburger" },
    { emoji: "🍟", name: "French Fries" },
    { emoji: "🍕", name: "Pizza" },
    { emoji: "🥪", name: "Sandwich" },
    { emoji: "🥙", name: "Stuffed Flatbread" },
    { emoji: "🌮", name: "Taco" },
    { emoji: "🌯", name: "Burrito" },
    { emoji: "🥗", name: "Green Salad" },
    { emoji: "🥘", name: "Shallow Pan of Food" },
    { emoji: "🥫", name: "Canned Food" },
    { emoji: "🍝", name: "Spaghetti" },
    { emoji: "🍜", name: "Steaming Bowl" },
    { emoji: "🍲", name: "Pot of Food" },
    { emoji: "🍛", name: "Curry Rice" },
    { emoji: "🍣", name: "Sushi" },
    { emoji: "🍱", name: "Bento Box" },
    { emoji: "🍚", name: "Cooked Rice" },
    { emoji: "🍙", name: "Rice Ball" },
    { emoji: "🍘", name: "Rice Cracker" },
    { emoji: "🍢", name: "Oden" },
    { emoji: "🍡", name: "Dango" },
    { emoji: "🍧", name: "Shaved Ice" },
    { emoji: "🍨", name: "Ice Cream" },
    { emoji: "🍦", name: "Soft Ice Cream" },
    { emoji: "🥧", name: "Pie" },
    { emoji: "🍰", name: "Shortcake" },
    { emoji: "🎂", name: "Birthday Cake" },
    { emoji: "🍮", name: "Custard" },
    { emoji: "🍭", name: "Lollipop" },
    { emoji: "🍬", name: "Candy" },
    { emoji: "🍫", name: "Chocolate Bar" },
    { emoji: "🍿", name: "Popcorn" },
    { emoji: "🍩", name: "Doughnut" },
    { emoji: "🍪", name: "Cookie" },
    { emoji: "🌰", name: "Chestnut" },
    { emoji: "🥜", name: "Peanuts" },
    { emoji: "🍯", name: "Honey Pot" },
    { emoji: "🥛", name: "Glass of Milk" },
    { emoji: "🍼", name: "Baby Bottle" },
    { emoji: "☕", name: "Hot Beverage" },
    { emoji: "🍵", name: "Teacup Without Handle" },
    { emoji: "🍶", name: "Sake" },
    { emoji: "🍺", name: "Beer Mug" },
    { emoji: "🍻", name: "Clinking Beer Mugs" },
    { emoji: "🥂", name: "Clinking Glasses" },
    { emoji: "🍷", name: "Wine Glass" },
    { emoji: "🥃", name: "Tumbler Glass" },
    { emoji: "🍸", name: "Cocktail Glass" },
    { emoji: "🍹", name: "Tropical Drink" },
    { emoji: "🍾", name: "Bottle with Popping Cork" },
  ],
  travel: [
    { emoji: "🚗", name: "Automobile" },
    { emoji: "🚕", name: "Taxi" },
    { emoji: "🚙", name: "Sport Utility Vehicle" },
    { emoji: "🚌", name: "Bus" },
    { emoji: "🚎", name: "Trolleybus" },
    { emoji: "🏎️", name: "Racing Car" },
    { emoji: "🚓", name: "Police Car" },
    { emoji: "🚑", name: "Ambulance" },
    { emoji: "🚒", name: "Fire Engine" },
    { emoji: "🚐", name: "Minibus" },
    { emoji: "🚚", name: "Delivery Truck" },
    { emoji: "🚛", name: "Articulated Lorry" },
    { emoji: "🚜", name: "Tractor" },
    { emoji: "🛴", name: "Kick Scooter" },
    { emoji: "🚲", name: "Bicycle" },
    { emoji: "🛵", name: "Motor Scooter" },
    { emoji: "🏍️", name: "Motorcycle" },
    { emoji: "🚨", name: "Police Car Light" },
    { emoji: "🚔", name: "Oncoming Police Car" },
    { emoji: "🚍", name: "Oncoming Bus" },
    { emoji: "🚘", name: "Oncoming Automobile" },
    { emoji: "🚖", name: "Oncoming Taxi" },
    { emoji: "🚡", name: "Aerial Tramway" },
    { emoji: "🚠", name: "Mountain Cableway" },
    { emoji: "🚟", name: "Suspension Railway" },
    { emoji: "🚃", name: "Railway Car" },
    { emoji: "🚋", name: "Tram Car" },
    { emoji: "🚞", name: "Mountain Railway" },
    { emoji: "🚝", name: "Monorail" },
    { emoji: "🚄", name: "High-Speed Train" },
    { emoji: "🚅", name: "Bullet Train" },
    { emoji: "🚈", name: "Light Rail" },
    { emoji: "🚂", name: "Locomotive" },
    { emoji: "🚆", name: "Train" },
    { emoji: "🚇", name: "Metro" },
    { emoji: "🚊", name: "Tram" },
    { emoji: "🚉", name: "Station" },
    { emoji: "✈️", name: "Airplane" },
    { emoji: "🛫", name: "Airplane Departure" },
    { emoji: "🛬", name: "Airplane Arrival" },
    { emoji: "🛩️", name: "Small Airplane" },
    { emoji: "💺", name: "Seat" },
    { emoji: "🚁", name: "Helicopter" },
    { emoji: "🛰️", name: "Satellite" },
    { emoji: "🚀", name: "Rocket" },
    { emoji: "🛸", name: "Flying Saucer" },
    { emoji: "⛵", name: "Sailboat" },
    { emoji: "🛥️", name: "Motor Boat" },
    { emoji: "🚤", name: "Speedboat" },
    { emoji: "🛳️", name: "Passenger Ship" },
    { emoji: "⛴️", name: "Ferry" },
    { emoji: "🚢", name: "Ship" },
    { emoji: "⚓", name: "Anchor" },
    { emoji: "⛽", name: "Fuel Pump" },
    { emoji: "🚧", name: "Construction" },
    { emoji: "🚦", name: "Vertical Traffic Light" },
    { emoji: "🚥", name: "Horizontal Traffic Light" },
    { emoji: "🗺️", name: "World Map" },
    { emoji: "🗿", name: "Moyai" },
    { emoji: "🗽", name: "Statue of Liberty" },
    { emoji: "🗼", name: "Tokyo Tower" },
    { emoji: "🏰", name: "European Castle" },
    { emoji: "🏯", name: "Japanese Castle" },
    { emoji: "🏟️", name: "Stadium" },
    { emoji: "🎡", name: "Ferris Wheel" },
    { emoji: "🎢", name: "Roller Coaster" },
    { emoji: "🎠", name: "Carousel Horse" },
    { emoji: "⛲", name: "Fountain" },
    { emoji: "⛱️", name: "Beach with Umbrella" },
    { emoji: "🏖️", name: "Beach" },
    { emoji: "🏝️", name: "Desert Island" },
    { emoji: "🏜️", name: "Desert" },
    { emoji: "🌋", name: "Volcano" },
    { emoji: "⛰️", name: "Mountain" },
    { emoji: "🏔️", name: "Snow-Capped Mountain" },
    { emoji: "🗻", name: "Mount Fuji" },
    { emoji: "🏕️", name: "Camping" },
    { emoji: "⛺", name: "Tent" },
    { emoji: "🏠", name: "House" },
    { emoji: "🏡", name: "House with Garden" },
    { emoji: "🏘️", name: "Houses" },
    { emoji: "🏚️", name: "Derelict House" },
    { emoji: "🏗️", name: "Building Construction" },
    { emoji: "🏭", name: "Factory" },
    { emoji: "🏢", name: "Office Building" },
    { emoji: "🏬", name: "Department Store" },
    { emoji: "🏣", name: "Japanese Post Office" },
    { emoji: "🏤", name: "Post Office" },
    { emoji: "🏥", name: "Hospital" },
    { emoji: "🏦", name: "Bank" },
    { emoji: "🏨", name: "Hotel" },
    { emoji: "🏪", name: "Convenience Store" },
    { emoji: "🏫", name: "School" },
    { emoji: "🏩", name: "Love Hotel" },
    { emoji: "💒", name: "Wedding" },
    { emoji: "🏛️", name: "Classical Building" },
    { emoji: "⛪", name: "Church" },
    { emoji: "🕌", name: "Mosque" },
    { emoji: "🕍", name: "Synagogue" },
    { emoji: "🕋", name: "Kaaba" },
    { emoji: "⛩️", name: "Shinto Shrine" },
  ],
  activities: [
    { emoji: "⚽", name: "Soccer Ball" },
    { emoji: "🏀", name: "Basketball" },
    { emoji: "🏈", name: "American Football" },
    { emoji: "⚾", name: "Baseball" },
    { emoji: "🎾", name: "Tennis" },
    { emoji: "🏐", name: "Volleyball" },
    { emoji: "🏉", name: "Rugby Football" },
    { emoji: "🎱", name: "Pool 8 Ball" },
    { emoji: "🏓", name: "Ping Pong" },
    { emoji: "🏸", name: "Badminton" },
    { emoji: "🥅", name: "Goal Net" },
    { emoji: "🏒", name: "Ice Hockey" },
    { emoji: "🏑", name: "Field Hockey" },
    { emoji: "🏏", name: "Cricket" },
    { emoji: "⛳", name: "Flag in Hole" },
    { emoji: "🏹", name: "Bow and Arrow" },
    { emoji: "🎣", name: "Fishing Pole" },
    { emoji: "🥊", name: "Boxing Glove" },
    { emoji: "🥋", name: "Martial Arts Uniform" },
    { emoji: "⛸️", name: "Ice Skate" },
    { emoji: "🎿", name: "Skis" },
    { emoji: "⛷️", name: "Skier" },
    { emoji: "🏂", name: "Snowboarder" },
    { emoji: "🏋️", name: "Weight Lifter" },
    { emoji: "🤼", name: "Wrestlers" },
    { emoji: "🤸", name: "Person Cartwheeling" },
    { emoji: "🤺", name: "Fencer" },
    { emoji: "🤾", name: "Handball" },
    { emoji: "🤽", name: "Water Polo" },
    { emoji: "🏊", name: "Swimmer" },
    { emoji: "🏄", name: "Surfer" },
    { emoji: "🏇", name: "Horse Racing" },
    { emoji: "🎯", name: "Direct Hit" },
    { emoji: "🎮", name: "Video Game" },
    { emoji: "🕹️", name: "Joystick" },
    { emoji: "🎰", name: "Slot Machine" },
    { emoji: "🎲", name: "Game Die" },
    { emoji: "🎳", name: "Bowling" },
    { emoji: "🎴", name: "Flower Playing Cards" },
    { emoji: "🎭", name: "Performing Arts" },
    { emoji: "🎨", name: "Artist Palette" },
    { emoji: "🎬", name: "Clapper Board" },
    { emoji: "🎤", name: "Microphone" },
    { emoji: "🎧", name: "Headphone" },
    { emoji: "🎼", name: "Musical Score" },
    { emoji: "🎹", name: "Musical Keyboard" },
    { emoji: "🥁", name: "Drum" },
    { emoji: "🎷", name: "Saxophone" },
    { emoji: "🎺", name: "Trumpet" },
    { emoji: "🎸", name: "Guitar" },
    { emoji: "🎻", name: "Violin" },
  ],
  objects: [
    { emoji: "⌚", name: "Watch" },
    { emoji: "📱", name: "Mobile Phone" },
    { emoji: "📲", name: "Mobile Phone with Arrow" },
    { emoji: "💻", name: "Laptop" },
    { emoji: "⌨️", name: "Keyboard" },
    { emoji: "🖥️", name: "Desktop Computer" },
    { emoji: "🖨️", name: "Printer" },
    { emoji: "🖱️", name: "Computer Mouse" },
    { emoji: "🖲️", name: "Trackball" },
    { emoji: "🕹️", name: "Joystick" },
    { emoji: "🗜️", name: "Clamp" },
    { emoji: "💾", name: "Floppy Disk" },
    { emoji: "💿", name: "Optical Disk" },
    { emoji: "📀", name: "DVD" },
    { emoji: "📼", name: "Videocassette" },
    { emoji: "📷", name: "Camera" },
    { emoji: "📸", name: "Camera with Flash" },
    { emoji: "📹", name: "Video Camera" },
    { emoji: "🎥", name: "Movie Camera" },
    { emoji: "📽️", name: "Film Projector" },
    { emoji: "🎞️", name: "Film Frames" },
    { emoji: "📞", name: "Telephone Receiver" },
    { emoji: "☎️", name: "Telephone" },
    { emoji: "📟", name: "Pager" },
    { emoji: "📠", name: "Fax Machine" },
    { emoji: "📺", name: "Television" },
    { emoji: "📻", name: "Radio" },
    { emoji: "🎙️", name: "Studio Microphone" },
    { emoji: "🎚️", name: "Level Slider" },
    { emoji: "🎛️", name: "Control Knobs" },
    { emoji: "⏱️", name: "Stopwatch" },
    { emoji: "⏲️", name: "Timer Clock" },
    { emoji: "⏰", name: "Alarm Clock" },
    { emoji: "🕰️", name: "Mantelpiece Clock" },
    { emoji: "⌛", name: "Hourglass Done" },
    { emoji: "⏳", name: "Hourglass Not Done" },
    { emoji: "📡", name: "Satellite Antenna" },
    { emoji: "🔋", name: "Battery" },
    { emoji: "🔌", name: "Electric Plug" },
    { emoji: "💡", name: "Light Bulb" },
    { emoji: "🔦", name: "Flashlight" },
    { emoji: "🕯️", name: "Candle" },
    { emoji: "🧯", name: "Fire Extinguisher" },
    { emoji: "🛢️", name: "Oil Drum" },
    { emoji: "💸", name: "Money with Wings" },
    { emoji: "💵", name: "Dollar Banknote" },
    { emoji: "💴", name: "Yen Banknote" },
    { emoji: "💶", name: "Euro Banknote" },
    { emoji: "💷", name: "Pound Banknote" },
    { emoji: "💰", name: "Money Bag" },
    { emoji: "💳", name: "Credit Card" },
    { emoji: "💎", name: "Gem Stone" },
    { emoji: "⚖️", name: "Balance Scale" },
    { emoji: "🧰", name: "Toolbox" },
    { emoji: "🔧", name: "Wrench" },
    { emoji: "🔨", name: "Hammer" },
    { emoji: "⚒️", name: "Hammer and Pick" },
    { emoji: "🛠️", name: "Hammer and Wrench" },
    { emoji: "⛏️", name: "Pick" },
    { emoji: "🔩", name: "Nut and Bolt" },
    { emoji: "⛓️", name: "Chains" },
    { emoji: "🧲", name: "Magnet" },
    { emoji: "🔫", name: "Pistol" },
    { emoji: "💣", name: "Bomb" },
    { emoji: "🧨", name: "Firecracker" },
    { emoji: "🔪", name: "Kitchen Knife" },
    { emoji: "🗡️", name: "Dagger" },
    { emoji: "⚔️", name: "Crossed Swords" },
    { emoji: "🛡️", name: "Shield" },
    { emoji: "🚬", name: "Cigarette" },
    { emoji: "⚰️", name: "Coffin" },
    { emoji: "⚱️", name: "Funeral Urn" },
    { emoji: "🏺", name: "Amphora" },
    { emoji: "🔮", name: "Crystal Ball" },
    { emoji: "📿", name: "Prayer Beads" },
    { emoji: "🧿", name: "Nazar Amulet" },
    { emoji: "💈", name: "Barber Pole" },
    { emoji: "⚗️", name: "Alembic" },
    { emoji: "🔭", name: "Telescope" },
    { emoji: "🔬", name: "Microscope" },
  ],
  symbols: [
    { emoji: "❤️", name: "Red Heart" },
    { emoji: "🧡", name: "Orange Heart" },
    { emoji: "💛", name: "Yellow Heart" },
    { emoji: "💚", name: "Green Heart" },
    { emoji: "💙", name: "Blue Heart" },
    { emoji: "💜", name: "Purple Heart" },
    { emoji: "🖤", name: "Black Heart" },
    { emoji: "💔", name: "Broken Heart" },
    { emoji: "❣️", name: "Heart Exclamation" },
    { emoji: "💕", name: "Two Hearts" },
    { emoji: "💞", name: "Revolving Hearts" },
    { emoji: "💓", name: "Beating Heart" },
    { emoji: "💗", name: "Growing Heart" },
    { emoji: "💖", name: "Sparkling Heart" },
    { emoji: "💘", name: "Heart with Arrow" },
    { emoji: "💝", name: "Heart with Ribbon" },
    { emoji: "💟", name: "Heart Decoration" },
    { emoji: "☮️", name: "Peace Symbol" },
    { emoji: "✝️", name: "Latin Cross" },
    { emoji: "☪️", name: "Star and Crescent" },
    { emoji: "🕉️", name: "Om" },
    { emoji: "☸️", name: "Wheel of Dharma" },
    { emoji: "✡️", name: "Star of David" },
    { emoji: "🔯", name: "Dotted Six-Pointed Star" },
    { emoji: "🕎", name: "Menorah" },
    { emoji: "☯️", name: "Yin Yang" },
    { emoji: "☦️", name: "Orthodox Cross" },
    { emoji: "🛐", name: "Place of Worship" },
    { emoji: "⛎", name: "Ophiuchus" },
    { emoji: "♈", name: "Aries" },
    { emoji: "♉", name: "Taurus" },
    { emoji: "♊", name: "Gemini" },
    { emoji: "♋", name: "Cancer" },
    { emoji: "♌", name: "Leo" },
    { emoji: "♍", name: "Virgo" },
    { emoji: "♎", name: "Libra" },
    { emoji: "♏", name: "Scorpius" },
    { emoji: "♐", name: "Sagittarius" },
    { emoji: "♑", name: "Capricorn" },
    { emoji: "♒", name: "Aquarius" },
    { emoji: "♓", name: "Pisces" },
    { emoji: "🆔", name: "ID Button" },
    { emoji: "⚛️", name: "Atom Symbol" },
    { emoji: "🉑", name: "Accept Button" },
    { emoji: "☢️", name: "Radioactive" },
    { emoji: "☣️", name: "Biohazard" },
    { emoji: "📴", name: "Mobile Phone Off" },
    { emoji: "📳", name: "Vibration Mode" },
    { emoji: "🈶", name: "Not Free of Charge" },
    { emoji: "🈚", name: "Free of Charge" },
    { emoji: "🈸", name: "Application" },
    { emoji: "🈺", name: "Open for Business" },
    { emoji: "🈷️", name: "Monthly Amount" },
    { emoji: "✴️", name: "Eight-Pointed Star" },
    { emoji: "🆚", name: "VS Button" },
    { emoji: "💮", name: "White Flower" },
    { emoji: "🉐", name: "Bargain" },
    { emoji: "㊙️", name: "Secret" },
    { emoji: "㊗️", name: "Congratulations" },
    { emoji: "🈴", name: "Passing Grade" },
    { emoji: "🈵", name: "No Vacancy" },
    { emoji: "🈹", name: "Discount" },
    { emoji: "🈲", name: "Prohibited" },
    { emoji: "🅰️", name: "A Button (Blood Type)" },
    { emoji: "🅱️", name: "B Button (Blood Type)" },
    { emoji: "🆎", name: "AB Button (Blood Type)" },
    { emoji: "🆑", name: "CL Button" },
    { emoji: "🅾️", name: "O Button (Blood Type)" },
    { emoji: "🆘", name: "SOS Button" },
    { emoji: "❌", name: "Cross Mark" },
    { emoji: "⭕", name: "Heavy Large Circle" },
    { emoji: "🛑", name: "Stop Sign" },
    { emoji: "⛔", name: "No Entry" },
    { emoji: "📛", name: "Name Badge" },
    { emoji: "🚫", name: "Prohibited" },
    { emoji: "💯", name: "Hundred Points" },
    { emoji: "💢", name: "Anger Symbol" },
    { emoji: "♨️", name: "Hot Springs" },
    { emoji: "🚷", name: "No Pedestrians" },
    { emoji: "🚯", name: "No Littering" },
    { emoji: "🚳", name: "No Bicycles" },
    { emoji: "🚱", name: "Non-Potable Water" },
    { emoji: "🔞", name: "No One Under Eighteen" },
    { emoji: "📵", name: "No Mobile Phones" },
    { emoji: "🚭", name: "No Smoking" },
    { emoji: "❗", name: "Exclamation Mark" },
    { emoji: "❓", name: "Question Mark" },
    { emoji: "❕", name: "White Exclamation Mark" },
    { emoji: "❔", name: "White Question Mark" },
    { emoji: "‼️", name: "Double Exclamation Mark" },
    { emoji: "⁉️", name: "Exclamation Question Mark" },
    { emoji: "🔅", name: "Dim Button" },
    { emoji: "🔆", name: "Bright Button" },
    { emoji: "〽️", name: "Part Alternation Mark" },
    { emoji: "⚠️", name: "Warning" },
    { emoji: "🚸", name: "Children Crossing" },
    { emoji: "🔱", name: "Trident Emblem" },
    { emoji: "⚜️", name: "Fleur-de-lis" },
    { emoji: "🔰", name: "Japanese Symbol for Beginner" },
    { emoji: "♻️", name: "Recycling Symbol" },
    { emoji: "✅", name: "Check Mark Button" },
    { emoji: "🈯", name: "Reserved" },
    { emoji: "💹", name: "Chart Increasing with Yen" },
    { emoji: "❇️", name: "Sparkle" },
    { emoji: "✳️", name: "Eight-Spoked Asterisk" },
    { emoji: "❎", name: "Cross Mark Button" },
    { emoji: "🌐", name: "Globe with Meridians" },
    { emoji: "💠", name: "Diamond with a Dot" },
    { emoji: "Ⓜ️", name: "Circled M" },
    { emoji: "🌀", name: "Cyclone" },
    { emoji: "💤", name: "ZZZ" },
    { emoji: "🏧", name: "ATM Sign" },
    { emoji: "🚾", name: "Water Closet" },
    { emoji: "♿", name: "Wheelchair Symbol" },
    { emoji: "🅿️", name: "P Button" },
    { emoji: "🈳", name: "Vacancy" },
    { emoji: "🈂️", name: "Service Charge" },
    { emoji: "🛂", name: "Passport Control" },
    { emoji: "🛃", name: "Customs" },
    { emoji: "🛅", name: "Left Luggage" },
  ],
  flags: [
    { emoji: "🏳️", name: "White Flag" },
    { emoji: "🏴", name: "Black Flag" },
    { emoji: "🏁", name: "Chequered Flag" },
    { emoji: "🚩", name: "Triangular Flag" },
    { emoji: "🏳️‍🌈", name: "Rainbow Flag" },
    { emoji: "🏳️‍⚧️", name: "Transgender Flag" },
    { emoji: "🇦🇫", name: "Afghanistan" },
    { emoji: "🇦🇽", name: "Åland Islands" },
    { emoji: "🇦🇱", name: "Albania" },
    { emoji: "🇩🇿", name: "Algeria" },
    { emoji: "🇦🇸", name: "American Samoa" },
    { emoji: "🇦🇩", name: "Andorra" },
    { emoji: "🇦🇴", name: "Angola" },
    { emoji: "🇦🇮", name: "Anguilla" },
    { emoji: "🇦🇶", name: "Antarctica" },
    { emoji: "🇦🇬", name: "Antigua & Barbuda" },
    { emoji: "🇦🇷", name: "Argentina" },
    { emoji: "🇦🇲", name: "Armenia" },
    { emoji: "🇦🇼", name: "Aruba" },
    { emoji: "🇦🇺", name: "Australia" },
    { emoji: "🇦🇹", name: "Austria" },
    { emoji: "🇦🇿", name: "Azerbaijan" },
    { emoji: "🇧🇸", name: "Bahamas" },
    { emoji: "🇧🇭", name: "Bahrain" },
    { emoji: "🇧🇩", name: "Bangladesh" },
    { emoji: "🇧🇧", name: "Barbados" },
    { emoji: "🇧🇾", name: "Belarus" },
    { emoji: "🇧🇪", name: "Belgium" },
    { emoji: "🇧🇿", name: "Belize" },
    { emoji: "🇧🇯", name: "Benin" },
    { emoji: "🇧🇲", name: "Bermuda" },
    { emoji: "🇧🇹", name: "Bhutan" },
    { emoji: "🇧🇴", name: "Bolivia" },
    { emoji: "🇧🇦", name: "Bosnia & Herzegovina" },
    { emoji: "🇧🇼", name: "Botswana" },
    { emoji: "🇧🇷", name: "Brazil" },
    { emoji: "🇮🇴", name: "British Indian Ocean Territory" },
    { emoji: "🇻🇬", name: "British Virgin Islands" },
    { emoji: "🇧🇳", name: "Brunei" },
    { emoji: "🇧🇬", name: "Bulgaria" },
    { emoji: "🇧🇫", name: "Burkina Faso" },
    { emoji: "🇧🇮", name: "Burundi" },
    { emoji: "🇰🇭", name: "Cambodia" },
    { emoji: "🇨🇲", name: "Cameroon" },
    { emoji: "🇨🇦", name: "Canada" },
    { emoji: "🇮🇨", name: "Canary Islands" },
    { emoji: "🇨🇻", name: "Cape Verde" },
    { emoji: "🇧🇶", name: "Caribbean Netherlands" },
    { emoji: "🇰🇾", name: "Cayman Islands" },
    { emoji: "🇨🇫", name: "Central African Republic" },
    { emoji: "🇹🇩", name: "Chad" },
    { emoji: "🇨🇱", name: "Chile" },
    { emoji: "🇨🇳", name: "China" },
    { emoji: "🇨🇽", name: "Christmas Island" },
    { emoji: "🇨🇨", name: "Cocos (Keeling) Islands" },
    { emoji: "🇨🇴", name: "Colombia" },
    { emoji: "🇰🇲", name: "Comoros" },
    { emoji: "🇨🇬", name: "Congo - Brazzaville" },
    { emoji: "🇨🇩", name: "Congo - Kinshasa" },
    { emoji: "🇨🇰", name: "Cook Islands" },
    { emoji: "🇨🇷", name: "Costa Rica" },
    { emoji: "🇨🇮", name: "Côte d'Ivoire" },
    { emoji: "🇭🇷", name: "Croatia" },
    { emoji: "🇨🇺", name: "Cuba" },
    { emoji: "🇨🇼", name: "Curaçao" },
    { emoji: "🇨🇾", name: "Cyprus" },
    { emoji: "🇨🇿", name: "Czechia" },
    { emoji: "🇩🇰", name: "Denmark" },
    { emoji: "🇩🇯", name: "Djibouti" },
    { emoji: "🇩🇲", name: "Dominica" },
    { emoji: "🇩🇴", name: "Dominican Republic" },
    { emoji: "🇪🇨", name: "Ecuador" },
    { emoji: "🇪🇬", name: "Egypt" },
    { emoji: "🇸🇻", name: "El Salvador" },
    { emoji: "🇬🇶", name: "Equatorial Guinea" },
    { emoji: "🇪🇷", name: "Eritrea" },
    { emoji: "🇪🇪", name: "Estonia" },
    { emoji: "🇪🇹", name: "Ethiopia" },
    { emoji: "🇪🇺", name: "European Union" },
    { emoji: "🇫🇰", name: "Falkland Islands" },
    { emoji: "🇫🇴", name: "Faroe Islands" },
    { emoji: "🇫🇯", name: "Fiji" },
    { emoji: "🇫🇮", name: "Finland" },
    { emoji: "🇫🇷", name: "France" },
    { emoji: "🇬🇫", name: "French Guiana" },
    { emoji: "🇵🇫", name: "French Polynesia" },
    { emoji: "🇹🇫", name: "French Southern Territories" },
    { emoji: "🇬🇦", name: "Gabon" },
    { emoji: "🇬🇲", name: "Gambia" },
    { emoji: "🇬🇪", name: "Georgia" },
    { emoji: "🇩🇪", name: "Germany" },
    { emoji: "🇬🇭", name: "Ghana" },
    { emoji: "🇬🇮", name: "Gibraltar" },
    { emoji: "🇬🇷", name: "Greece" },
    { emoji: "🇬🇱", name: "Greenland" },
    { emoji: "🇬🇩", name: "Grenada" },
    { emoji: "🇬🇵", name: "Guadeloupe" },
    { emoji: "🇬🇺", name: "Guam" },
    { emoji: "🇬🇹", name: "Guatemala" },
    { emoji: "🇬🇬", name: "Guernsey" },
    { emoji: "🇬🇳", name: "Guinea" },
    { emoji: "🇬🇼", name: "Guinea-Bissau" },
    { emoji: "🇬🇾", name: "Guyana" },
    { emoji: "🇭🇹", name: "Haiti" },
    { emoji: "🇭🇳", name: "Honduras" },
    { emoji: "🇭🇰", name: "Hong Kong SAR China" },
    { emoji: "🇭🇺", name: "Hungary" },
    { emoji: "🇮🇸", name: "Iceland" },
    { emoji: "🇮🇳", name: "India" },
    { emoji: "🇮🇩", name: "Indonesia" },
    { emoji: "🇮🇷", name: "Iran" },
    { emoji: "🇮🇶", name: "Iraq" },
    { emoji: "🇮🇪", name: "Ireland" },
    { emoji: "🇮🇲", name: "Isle of Man" },
    { emoji: "🇮🇱", name: "Israel" },
    { emoji: "🇮🇹", name: "Italy" },
    { emoji: "🇯🇲", name: "Jamaica" },
    { emoji: "🇯🇵", name: "Japan" },
    { emoji: "🇯🇪", name: "Jersey" },
    { emoji: "🇯🇴", name: "Jordan" },
    { emoji: "🇰🇿", name: "Kazakhstan" },
    { emoji: "🇰🇪", name: "Kenya" },
    { emoji: "🇰🇮", name: "Kiribati" },
    { emoji: "🇽🇰", name: "Kosovo" },
    { emoji: "🇰🇼", name: "Kuwait" },
    { emoji: "🇰🇬", name: "Kyrgyzstan" },
    { emoji: "🇱🇦", name: "Laos" },
    { emoji: "🇱🇻", name: "Latvia" },
    { emoji: "🇱🇧", name: "Lebanon" },
    { emoji: "🇱🇸", name: "Lesotho" },
    { emoji: "🇱🇷", name: "Liberia" },
    { emoji: "🇱🇾", name: "Libya" },
    { emoji: "🇱🇮", name: "Liechtenstein" },
    { emoji: "🇱🇹", name: "Lithuania" },
    { emoji: "🇱🇺", name: "Luxembourg" },
    { emoji: "🇲🇴", name: "Macao SAR China" },
    { emoji: "🇲🇰", name: "North Macedonia" },
    { emoji: "🇲🇬", name: "Madagascar" },
    { emoji: "🇲🇼", name: "Malawi" },
    { emoji: "🇲🇾", name: "Malaysia" },
    { emoji: "🇲🇻", name: "Maldives" },
    { emoji: "🇲🇱", name: "Mali" },
    { emoji: "🇲🇹", name: "Malta" },
    { emoji: "🇲🇭", name: "Marshall Islands" },
    { emoji: "🇲🇶", name: "Martinique" },
    { emoji: "🇲🇷", name: "Mauritania" },
    { emoji: "🇲🇺", name: "Mauritius" },
    { emoji: "🇾🇹", name: "Mayotte" },
    { emoji: "🇲🇽", name: "Mexico" },
    { emoji: "🇫🇲", name: "Micronesia" },
    { emoji: "🇲🇩", name: "Moldova" },
    { emoji: "🇲🇨", name: "Monaco" },
    { emoji: "🇲🇳", name: "Mongolia" },
    { emoji: "🇲🇪", name: "Montenegro" },
    { emoji: "🇲🇸", name: "Montserrat" },
    { emoji: "🇲🇦", name: "Morocco" },
    { emoji: "🇲🇿", name: "Mozambique" },
    { emoji: "🇲🇲", name: "Myanmar (Burma)" },
    { emoji: "🇳🇦", name: "Namibia" },
    { emoji: "🇳🇷", name: "Nauru" },
    { emoji: "🇳🇵", name: "Nepal" },
    { emoji: "🇳🇱", name: "Netherlands" },
    { emoji: "🇳🇨", name: "New Caledonia" },
    { emoji: "🇳🇿", name: "New Zealand" },
    { emoji: "🇳🇮", name: "Nicaragua" },
    { emoji: "🇳🇪", name: "Niger" },
    { emoji: "🇳🇬", name: "Nigeria" },
    { emoji: "🇳🇺", name: "Niue" },
    { emoji: "🇳🇫", name: "Norfolk Island" },
    { emoji: "🇰🇵", name: "North Korea" },
    { emoji: "🇲🇵", name: "Northern Mariana Islands" },
    { emoji: "🇳🇴", name: "Norway" },
    { emoji: "🇴🇲", name: "Oman" },
    { emoji: "🇵🇰", name: "Pakistan" },
    { emoji: "🇵🇼", name: "Palau" },
    { emoji: "🇵🇸", name: "Palestinian Territories" },
    { emoji: "🇵🇦", name: "Panama" },
    { emoji: "🇵🇬", name: "Papua New Guinea" },
    { emoji: "🇵🇾", name: "Paraguay" },
    { emoji: "🇵🇪", name: "Peru" },
    { emoji: "🇵🇭", name: "Philippines" },
    { emoji: "🇵🇳", name: "Pitcairn Islands" },
    { emoji: "🇵🇱", name: "Poland" },
    { emoji: "🇵🇹", name: "Portugal" },
    { emoji: "🇵🇷", name: "Puerto Rico" },
    { emoji: "🇶🇦", name: "Qatar" },
    { emoji: "🇷🇪", name: "Réunion" },
    { emoji: "🇷🇴", name: "Romania" },
    { emoji: "🇷🇺", name: "Russia" },
    { emoji: "🇷🇼", name: "Rwanda" },
    { emoji: "🇼🇸", name: "Samoa" },
    { emoji: "🇸🇲", name: "San Marino" },
    { emoji: "🇸🇦", name: "São Tomé & Príncipe" },
    { emoji: "🇸🇳", name: "Senegal" },
    { emoji: "🇷🇸", name: "Serbia" },
    { emoji: "🇸🇨", name: "Seychelles" },
    { emoji: "🇸🇱", name: "Sierra Leone" },
    { emoji: "🇸🇬", name: "Singapore" },
    { emoji: "🇸🇽", name: "Sint Maarten" },
    { emoji: "🇸🇰", name: "Slovakia" },
    { emoji: "🇸🇮", name: "Slovenia" },
    { emoji: "🇸🇧", name: "Solomon Islands" },
    { emoji: "🇸🇴", name: "Somalia" },
    { emoji: "🇿🇦", name: "South Africa" },
    { emoji: "🇬🇸", name: "South Georgia & South Sandwich Islands" },
    { emoji: "🇰🇷", name: "South Korea" },
    { emoji: "🇸🇸", name: "South Sudan" },
    { emoji: "🇪🇸", name: "Spain" },
    { emoji: "🇱🇰", name: "Sri Lanka" },
    { emoji: "🇧🇱", name: "St. Barthélemy" },
    { emoji: "🇸🇭", name: "St. Helena" },
    { emoji: "🇰🇳", name: "St. Kitts & Nevis" },
    { emoji: "🇱🇨", name: "St. Lucia" },
    { emoji: "🇲🇫", name: "St. Martin" },
    { emoji: "🇵🇲", name: "St. Pierre & Miquelon" },
    { emoji: "🇻🇨", name: "St. Vincent & Grenadines" },
    { emoji: "🇸🇩", name: "Sudan" },
    { emoji: "🇸🇷", name: "Suriname" },
    { emoji: "🇸🇯", name: "Svalbard & Jan Mayen" },
    { emoji: "🇸🇪", name: "Sweden" },
    { emoji: "🇨🇭", name: "Switzerland" },
    { emoji: "🇸🇾", name: "Syria" },
    { emoji: "🇹🇼", name: "Taiwan" },
    { emoji: "🇹🇯", name: "Tajikistan" },
    { emoji: "🇹🇿", name: "Tanzania" },
    { emoji: "🇹🇭", name: "Thailand" },
    { emoji: "🇹🇱", name: "Timor-Leste" },
    { emoji: "🇹🇬", name: "Togo" },
    { emoji: "🇹🇰", name: "Tokelau" },
    { emoji: "🇹🇴", name: "Tonga" },
    { emoji: "🇹🇹", name: "Trinidad & Tobago" },
    { emoji: "🇹🇳", name: "Tunisia" },
    { emoji: "🇹🇷", name: "Turkey" },
    { emoji: "🇹🇲", name: "Turkmenistan" },
    { emoji: "🇹🇨", name: "Turks & Caicos Islands" },
    { emoji: "🇹🇻", name: "Tuvalu" },
    { emoji: "🇺🇬", name: "Uganda" },
    { emoji: "🇺🇦", name: "Ukraine" },
    { emoji: "🇦🇪", name: "United Arab Emirates" },
    { emoji: "🇬🇧", name: "United Kingdom" },
    { emoji: "🇺🇸", name: "United States" },
    { emoji: "🇺🇾", name: "Uruguay" },
    { emoji: "🇺🇿", name: "Uzbekistan" },
    { emoji: "🇻🇺", name: "Vanuatu" },
    { emoji: "🇻🇦", name: "Vatican City" },
    { emoji: "🇻🇪", name: "Venezuela" },
    { emoji: "🇻🇳", name: "Vietnam" },
    { emoji: "🇻🇬", name: "British Virgin Islands" },
    { emoji: "🇻🇮", name: "U.S. Virgin Islands" },
    { emoji: "🇼🇫", name: "Wallis & Futuna" },
    { emoji: "🇪🇭", name: "Western Sahara" },
    { emoji: "🇾🇪", name: "Yemen" },
    { emoji: "🇿🇲", name: "Zambia" },
    { emoji: "🇿🇼", name: "Zimbabwe" },
  ],
};
